import {
  Box,
  Typography,
} from "@mui/material";
import "./Banner.css";

function Banner() {
  return (
    <Box
      className="banner"
      sx={{
        padding: { xs: "1.3rem", sm: "2rem", md: "2rem" },
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontWeight: "bold",
          fontSize: { xs: "1.5rem", sm: "2.5rem", md: "3rem", lg: "3rem" },
          lineHeight: { xs: "2rem", sm: "3rem", md: "4rem", lg: "3.5rem" },
        }}
      >
        Find Qualified <span style={{ color: "#F5B500" }}>Professionals</span>,
        <br />
        Hassle-Free.
      </Typography>
    </Box>
  );
}

export default Banner;
